import { Injectable } from '@angular/core';
import * as Query from '@core/queries';
import { map } from 'rxjs/operators';
import { GraphQLService } from '@core/backend';
import { ChangePlatformsStatusInputDto, PlatformsBackend } from '@core/models';

@Injectable({ providedIn: 'root' })
export class AdminService {
  constructor(private graphqlService: GraphQLService) {}

  getAppliedCouponCodes$(email: string) {
    return this.graphqlService.get(Query.getAppliedCouponCodes({ email })).pipe(map((result) => result.data));
  }

  getEmailRelatedWithCouponCode$(coupon: string) {
    return this.graphqlService.get(Query.getEmailRelatedWithCouponCode({ coupon })).pipe(map((result) => result.data));
  }

  getNumberOfAppliedCouponCodes$() {
    return this.graphqlService.get(Query.getNumberOfAppliedCouponCodes()).pipe(map((result) => result.data));
  }

  getNumberOfNonAppliedCouponCodes$() {
    return this.graphqlService.get(Query.getNumberOfNonAppliedCouponCodes()).pipe(map((result) => result.data));
  }

  getUserInfo$(email: string) {
    return this.graphqlService.get(Query.getUserInfo({ email })).pipe(map((result) => result.data));
  }

  isAdmin$() {
    return this.graphqlService.get(Query.isAdmin()).pipe(map((result) => result.data));
  }

  getPlatformStatusAcrossTheApp$() {
    return this.graphqlService.get(Query.getPlatformStatusAcrossTheApp()).pipe(map((result) => result.data));
  }

  changePlatformsStatusAcrossTheApp$(accessPreferences: ChangePlatformsStatusInputDto) {
    return this.graphqlService
      .post(Query.changePlatformsStatusAcrossTheApp({ accessPreferences: accessPreferences }))
      .pipe(map((result) => result.data));
  }

  disconnectPlatformOfUser$(email: string, platform: PlatformsBackend) {
    return this.graphqlService
      .post(Query.disconnectPlatformOfUser({ email, platform }))
      .pipe(map((result) => result.data));
  }
}
